import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";

import htmldecoder from "../../../../functions/htmldecoder";

import { I18nContext } from "../../../../i18n/index";
import "./Styles/OtherInfoTab.css";

const OtherInfoTab = ({ longDesc, properties }) => {
  const { translate } = React.useContext(I18nContext);
  console.info("properties", properties);
  return (
    <div
      className="product-details-specs-container"
      style={{ backgroundColor: "white" }}
    >
      <div className="product-details-specs-wrapper">
        <div className="product-details-wrapper">
          <h2>{translate("js.item.productdetails")}</h2>
          <ul id="description" className="otherDesktop">
            {Object.keys(longDesc).map((desc, index) => {
              if (longDesc[desc] !== "") {
                return (
                  <li
                    key={index}
                    dangerouslySetInnerHTML={{
                      __html: htmldecoder(longDesc[desc])
                    }}
                  />
                );
              }
            })}

            {Array.isArray(properties) && properties.length > 0 &&
              [...properties]
                .sort((a, b) => {
                  const keyA = String(a.propdesc || "").toLowerCase();
                  const keyB = String(b.propdesc || "").toLowerCase();
                  return keyA.localeCompare(keyB);
                })
                .map(property => {
                  const key = property.propdesc;
                  const value = property.propvalue;
                  if (
                    typeof key === "string" &&
                    !key.includes("_") &&
                    !["UPC", "Stock", "Quantity"].includes(key) &&
                    value !== undefined &&
                    value !== null &&
                    value !== ""
                  ) {
                    return (
                      <li className="specs-list-item" key={key}>
                        <label>
                          <strong>{key}:&nbsp;</strong>
                        </label>
                        <span>{value}</span>
                      </li>
                    );
                  }
                  return null;
                })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OtherInfoTab;
